interface Props {
  error: unknown;
  resetError: () => void;
}

export function SentryFallback({ error, resetError }: Props) {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#0a0a0f",
      color: "#e5e5e5",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem",
      fontFamily: "system-ui, sans-serif",
      textAlign: "center",
    }}>
      <h1 style={{ color: "#00e5ff", marginBottom: "1rem" }}>Algo deu errado</h1>
      <p style={{ opacity: 0.7, marginBottom: "2rem", maxWidth: "400px" }}>
        Tivemos um problema inesperado. A equipe foi notificada automaticamente.
      </p>
      <button
        onClick={resetError}
        style={{
          background: "#00e5ff",
          color: "#0a0a0f",
          border: "none",
          padding: "0.75rem 1.5rem",
          borderRadius: "8px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Tentar novamente
      </button>
    </div>
  );
}
